import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query'
import { getTranslations } from "../api/languageApi";
import { applyTranslations } from "./constants";
import { getUserLanguage, setUserLanguage } from './localStorage'
import { clearApiGetCache } from '../api/apiWrapper'
import { clearAllCache } from '../api/cache'

try {
  applyTranslations({}, getUserLanguage() || 'en')
} catch (e) {
  console.warn('Default translations failed:', e)
}

const LanguageContext = createContext();
export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const queryClient = useQueryClient()
  const [language, setLanguage] = useState(
    getUserLanguage() || "en"
  );
    const [isLangLoading, setIsLangLoading] = useState(false)


  useEffect(() => {
     let active = true
    const load = async () => {
       setIsLangLoading(true)
      try {
        const apiData = await getTranslations({ language_code: language });
        if (!active) return
        applyTranslations(apiData, language);
      } catch (error) {
        console.error("Translation API failed:", error);
        applyTranslations({}, language); // fallback / default translations
      } finally {
        setUserLanguage(language);
        try {
          clearApiGetCache()
          clearAllCache()
        } catch (e) {
          console.warn('Cache clear failed', e)
        }

        try {
          queryClient.invalidateQueries()
        } catch (e) {
          console.warn('QueryClient invalidate failed', e)
        }

        if (active) setIsLangLoading(false)
      }
    };

    load();
  }, [language]);


  const toggleLanguage = (key) => {
   
    setLanguage(key)
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isLangLoading  }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node
};

